export default "__VITE_ASSET__Dct0VrJO__"